import {
  ADDITIONAL_CUT_LINE_PREFIX_ID,
} from "@frontend/constants/templates-field-prefixes";
import {getSettingsDataInstance, removeObjectFromCanvas} from "@frontend/utils";
import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";
import {FIELD_TYPE_CUT_LINE} from "@frontend/constants/type-fields-of-template";
import {scaleControlsCornerSize} from "@frontend/constants/fabric-constants";
import {ORIENTATION} from "@frontend/constants/orientation";

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export const drawAdditionalCutLine = ({ canvas, id }) => {
  removeObjectFromCanvas(canvas, ADDITIONAL_CUT_LINE_PREFIX_ID);

  const {canvas_data} = getScopePage();
  const settingsTemplate = getSettingsDataInstance(canvas_data[id]._data?.settings_template);

  canvas_data[id].additionalCutLines.forEach((elementId, index) => {
    const x = parseInt(canvas_data[id]._data[`${elementId}_offset_x`]);
    const y = parseInt(canvas_data[id]._data[`${elementId}_offset_y`]);
    const strokeWidth = parseInt(canvas_data[id]._data[`${elementId}_thickness`]);
    const visible = canvas_data[id]._data[`${elementId}_visible`] ?? true;
    const order = 0;
    const objectId = ADDITIONAL_CUT_LINE_PREFIX_ID + index;
    const strokeColor = canvas_data[id]._data[`${elementId}_stroke_color`];
    const coords = canvas_data[id]._data[`${elementId}_coords`];
    const orientation = canvas_data[id]._data[`${elementId}_orientation`];
    const includeLineWidth = canvas_data[id]._data[`${elementId}_include_line_width`] ?? true;

    const cutLine = new fabric.Line(
      coords,
      {
        id: objectId,
        fieldType: FIELD_TYPE_CUT_LINE,
        element_id: elementId,
        order,
        selectable: true,
        evented: true,
        visible: visible,
        left: x,
        top: y,
        name: settingsTemplate.getNameById(objectId, 'Additional Cut Line ' + (index + 1)),
        coords,
        fill: strokeColor,
        stroke: strokeColor,
        strokeWidth,
        orientation,
        lockMovementX: orientation === ORIENTATION.HORIZONTAL,
        lockMovementY: orientation === ORIENTATION.VERTICAL,
        lockScalingX: true,
        lockScalingY: true,
        lockRotation: true,
        lockUniScaling: true,
        includeLineWidth
      }
    );


    scaleControlsCornerSize(cutLine);

    canvas.add(cutLine);
  });
}
